import { render, staticRenderFns } from "./register-dialog.vue?vue&type=template&id=7a84dfd3&lang=pug&"
import script from "./register-dialog.vue?vue&type=script&lang=ts&"
export * from "./register-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports